import React from 'react'
import './add-file.styles.scss'
import Worker from './worker'
import FormHelper from '../../../../utils/FormHelper'
import Form from './form.component'
import Loading from '../../../../components/loading/loading.component'

class AddFile extends React.Component {

    constructor(props) {
        super(props)
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState()
    }

    onSubmit = e => {
        e.preventDefault()
        this.worker.isValid() && this.worker.addFile()
    }

    render() {
        return (
            <div className="add-file card">
                <div className="header">
                    <h4>Add File</h4>
                </div>
                <div className={"flag " + this.state.flag.type}>
                    {this.state.flag.text}
                </div>
                {this.state.creating? <Loading/>:<Form {...this.state} onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.props.onCancel}/>}
            </div>
        )
    }
}

export default AddFile